// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LKrl8BZ4{display:flex;flex-direction:column;gap:5px;position:relative}.K_YYgLhH{font-weight:500}.MBkLAzQo{color:#ff4c4c}.TLx4Fgia{color:#8496af;text-align:right}.XDwFuyn0{color:#ff4c4c}`, "",{"version":3,"sources":["webpack://./src/fsd/shared/ui/form-field/FormField.module.scss"],"names":[],"mappings":"AAAA,UACE,YAAA,CACA,qBAAA,CACA,OAAA,CACA,iBAAA,CAGF,UACE,eAAA,CAGF,UACE,aAAA,CAGF,UACE,aAAA,CACA,gBAAA,CAGF,UACE,aAAA","sourcesContent":[".wrap {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n  position: relative;\n}\n\n.label {\n  font-weight: 500;\n}\n\n.errorText {\n  color: #ff4c4c;\n}\n\n.description {\n  color: #8496af;\n  text-align: right;\n}\n\n.required {\n  color: #ff4c4c;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `LKrl8BZ4`,
	"label": `K_YYgLhH`,
	"errorText": `MBkLAzQo`,
	"description": `TLx4Fgia`,
	"required": `XDwFuyn0`
};
export default ___CSS_LOADER_EXPORT___;
